import { ChangeDetectionStrategy, Component, computed, EventEmitter, inject, input, InputSignal, Output, Signal } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { FormGroup, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatCard, MatCardContent } from '@angular/material/card';
import { MatRipple } from '@angular/material/core';
import { QuantityCounterComponent } from '@libs/form/components';
import { QuantityCounterInputModel } from '@libs/form/models';
import { ProductBundleItemModel, ProductBundleType } from '@libs/shop/models';
import { ViewportService } from '@libs/shared/services';
import { ProductPriceFormatterComponent } from '../product-prices/product-price-formatter';
import { ProductBundleCounterData } from './product-bundle-item.form.model';

@Component({
  selector: 'ui-product-bundle-item',
  imports: [
    QuantityCounterComponent,
    ReactiveFormsModule,
    MatCardContent,
    MatCard,
    MatRipple,
    ProductPriceFormatterComponent,
  ],
  templateUrl: './product-bundle-item.component.html',
  styleUrl: './product-bundle-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductBundleItemComponent {
  @Output()
  public quantityChanged: EventEmitter<number> = new EventEmitter<number>();

  public arePricesVisible: InputSignal<boolean> = input.required();
  public bundleType: InputSignal<ProductBundleType> = input.required();
  public bundleItem: InputSignal<ProductBundleItemModel> = input.required();
  public isFreeItem: InputSignal<boolean> = input.required();

  public readonly dataQuantityCounter: Signal<QuantityCounterInputModel> = computed(() => this.getQuantityCounterConfig(this.bundleType(), this.bundleItem()));

  public readonly quantityCounterControl: UntypedFormControl = new UntypedFormControl();
  public readonly group: FormGroup = new UntypedFormGroup({
    [ProductBundleCounterData.name]: this.quantityCounterControl,
  });

  public isMobile: Signal<boolean>;
  private readonly viewPortService: ViewportService = inject(ViewportService);

  public constructor() {
    this.isMobile = toSignal(this.viewPortService.isMobile(), { initialValue: false });
    this.quantityCounterControl.valueChanges.pipe(takeUntilDestroyed()).subscribe((value: number) => {
      this.quantityChanged.emit(value);
    });
  }

  public getQuantityCounterConfig(bundleType: ProductBundleType, bundleItem: ProductBundleItemModel): QuantityCounterInputModel {
    let config: QuantityCounterInputModel = ProductBundleCounterData;

    config = {
      ...config,
      value: bundleItem.quantity,
      attributes: {
        ...config.attributes,
        disabled: bundleType !== 'open',
      },
    };

    return config;
  }
}
